module Widgets.Confirmation where

import Common

import Concur.React.DOM as D
import Concur.React.Props as P
import Widgets.Modal (ModalResult(..), modalWidget)

-- | Displays the confirmation widget in a modal. Closing the modal counts as a no.
confirmModal :: forall a. Widget HTML a -> String -> String -> String -> Widget HTML Boolean
confirmModal outer title primaryButtonText msg = modalWidget outer (confirmWidget title primaryButtonText msg) >>= case _ of
    ModalClosed -> pure false
    ModalReturned v -> pure v

-- | Displays the given title and message with yes/no buttons and returns true if yes was
-- | clicked, otherwise false.
confirmWidget :: String -> String -> String -> Widget HTML Boolean
confirmWidget title primaryButtonText msg = D.div
    [ P.className "confirmation-widget modal-grid" ]
    [ D.h1
        [ P.className "modal-heading" ]
        [ D.text title ]
    , D.p
        [ P.className "modal-body" ]
        [ D.text msg ]
    , D.div
        [ P.className "btn-group btn-group-confirmation-dialog modal-buttons" ]
        [ D.button
            [ P.className "btn"
            , false <$ P.onClick ]
            [ D.text $ lookupTranslation "cancel" ]
        , D.button
            [ P.className "btn btn-primary"
            , true <$ P.onClick ]
            [ D.text $ primaryButtonText ]
        ]
    ]
